import { render, staticRenderFns } from "./ResignPersonnel.vue?vue&type=template&id=d1e22c2c&"
import script from "./ResignPersonnel.vue?vue&type=script&lang=js&"
export * from "./ResignPersonnel.vue?vue&type=script&lang=js&"
import style0 from "./ResignPersonnel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports